import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

const LandItSplashStyles = styled.div`
  form {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .search-field-group {
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: center;
      width: 100%;

      .city-location-container {
        margin-top: 50px;
      }
    }

    div {
      width: 100%;

      .text-input {
        background-color: #fff;
        border: solid 1px #d6d7d9;
        box-sizing: border-box;
        color: ${Colors.grayscaleCoolGray11};
        font-family: 'source-sans-pro', sans-serif;
        font-size: 16px;
        height: 42px;
        line-height: 1.56;
        letter-spacing: -0.3px;
        padding: 9px 33px 8px 13px;
        text-align: left;
        width: 100%;
      }

      .city-location-container {
        margin-top: -10px;
        width: 90%;
        .city-search-results {
          width: auto;
        }
      }
    }

    button {
      width: 75px;
    }
  }

  .splash-container {
    position: relative;
    align-items: center;
    background: url('/public-assets/images/california-hills.jpg') no-repeat
      center center fixed;
    background-size: cover;
    display: flex;
    height: calc(100vh - 55px);
    width: 100%;

    .search-container {
      margin: 0 auto;
      width: 90%;
      h1 {
        color: #fff;
        text-shadow: 1px 3px 4px #4e5255;
        /* color: #4e5255; */
        font-size: 40px;
        font-weight: 800;
        line-height: 1.2;
        letter-spacing: -0.44px;
        text-align: center;
      }
      p {
        color: #fff;
        text-shadow: 2px 2px 2px #4e5255;
        /* color: #4e5255; */
        text-align: center;
        margin-bottom: 50px;
      }
      .search-box {
        margin: 0 auto;
        .search-bar {
          width: 100%;

          input {
            height: 50px;
            float: left;
            font-size: 14px;
            font-family: source-sans-pro, sans-serif;
          }

          button {
            float: left;
            cursor: pointer;
            font-size: 14px;
            padding: 15px 20px 15px 20px;
            height: 50px;
            span {
              font-family: source-sans-pro, sans-serif;
              font-size: 14px;
            }
          }
          .error-msg {
            background-color: white;
            color: rgb(239, 75, 93);
            text-shadow: none;
            max-width: 500px;
            margin-top: 1px;
            width: 100%;
            margin-bottom: 0;
          }
        }
      }
    }
    .terms-link {
      position: absolute;
      bottom: 12px;
      right: 20px;
      text-align: right;

      a {
        color: #fff;
        font-size: 12px;
        text-decoration: none;
        cursor: pointer;
        text-shadow: 1px 2px 3px #4e5255;
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    div {
      width: 400px;
    }

    .splash-container {
      align-items: center;
      background: url('/public-assets/images/california-hills@3x.jpg') no-repeat
        center center fixed;
      background-size: cover;
      display: flex;
      justify-content: center;
      height: calc(100vh - 90px);
      width: 100%;

      .search-container {
        width: 60%;

        h1 {
          color: #fff;
          text-shadow: 1px 3px 4px #4e5255;
          /* color: #4e5255; */
          font-size: 50px;
          font-weight: 800;
          line-height: 1.2;
          letter-spacing: -0.44px;
          text-align: center;
        }

        .city-location-container {
          width: 400px;
        }
      }

      .terms-link {
        position: absolute;
        bottom: 12px;
        right: 20px;

        a {
          color: #fff;
          font-size: 12px;
          text-decoration: none;
          cursor: pointer;
        }
      }
    }
  }
`;

export default LandItSplashStyles;
